import React, { Component } from 'react';
import CommonCharts from '../../../components/Charts';
import moment from 'moment';
import ExportUtil from '../../../../../common/ExportUtil';
import API_URL from '../../../../../common/url';

class Charts extends Component {
    constructor(props) {
        super(props);
    }

    handleClick = () => {
        const { searchParams } = this.props;
        let url = API_URL.home.exportInvoicingList;
        searchParams.type="Invoicing";
        const{year}=searchParams;
        searchParams.year=year?year:moment().format('YYYY'),
        ExportUtil.export({ ...searchParams }, null, url);
    }

    render() {
        const { 
            data, height,searchParams,filename,searchInfo={} } = this.props;
        const categories = [];
        const lastYearAmountList = [];
        const currentYearAmountList = [];
        const lastYearNumList = [];
        const currentYearNumList = [];
        (data || []).forEach(item => {
            const { title,lastYearAmount,currentYearAmount,lastYearNum,currentYearNum } = item;
                categories.push(title);
                lastYearAmountList.push(lastYearAmount);
                currentYearAmountList.push(currentYearAmount);
                lastYearNumList.push(lastYearNum);
                currentYearNumList.push(currentYearNum);
        });
        const{year=moment().format('YYYY')}=searchParams;
        const lastYear = moment(year).subtract(1, 'year').format('YYYY');
        const searchYear =searchInfo&&searchInfo.year;
        const searchlastYear = moment(searchYear).subtract(1, 'year').format('YYYY');
        return (
            <div className="chart-content">
              <CommonCharts
                height={height}
                filename={filename}
                xAxis={{
                    categories,
                    crosshair: true
                }}
                yAxis={[{
                    title: {
                        text:'单位：万元/人民币',
                    },
                    // labels: {
                    //     formatter() {
                    //         const data = this.chart.series ? this.chart.series[0] : {};
                    //         if ((Object.keys(data).length > 0)) {
                    //                 return `${this.value / 1000000 } 百万`;                               
                    //         }
                    //         return this.value;
                    //     },
                    // },
                },
                {
                    title: {
                        text: null,
                    },
                    opposite: true
                }
               ]}
                series={[
                    {
                        name: `${searchlastYear?searchlastYear:lastYear}金额`,
                        type: 'column',
                        yAxis: 0,
                        data: lastYearAmountList,
                        color:"#6b95f2",
                        dataLabels: {
                            //enabled: true,
                            //inside: false,
                            borderRadius: 0,
                            backgroundColor: 'none',
                            borderWidth: 0,
                            style:{
                                textOutline:"none",
                                color: '#6b95f2'
                            }
                        }
                    },
                    {
                    name: `${searchYear?searchYear:year}金额`,
                    type: 'column',
                    yAxis: 0,
                    data: currentYearAmountList,
                    color:"#83d7ad",
                    dataLabels: {
                        //enabled: true,
                        //inside: false,
                        borderRadius: 0,
                        backgroundColor: 'none',
                        borderWidth: 0,
                        style:{
                            textOutline:"none",
                            color: '#83d7ad'
                        }
                    }
                    }, {
                        name: `${searchlastYear?searchlastYear:lastYear}笔数`,
                        type: 'spline',
                        yAxis: 1,
                        data: lastYearNumList,
                        color:"#ffbf00",
                        dataLabels: {
                            borderRadius: 0,
                            backgroundColor: 'none',
                            borderWidth: 0,
                            style:{
                                textOutline:"none",
                                color:"#ffbf00",
                            }
                        }
                    }, {
                        name: `${searchYear?searchYear:year}笔数`,
                        type: 'spline',
                        yAxis: 1,
                        data: currentYearNumList,
                        color:"rgb(247, 163, 92)",
                        dataLabels: {
                            borderRadius: 0,
                            backgroundColor: 'none',
                            borderWidth: 0,
                            style:{
                                textOutline:"none",
                                color:"rgb(247, 163, 92)",
                            }
                        }
                    }
                  ]}
                // plotOptions={ {
                //     column: {
                //         dataLabels: {
                //             enabled: false,
                //             inside: false,
                //             color: '#000000'
                //         }
                //     }
                // }}
                onClick={this.handleClick}
                fromRequestSheet={true}
            />
           </div> 
        );
    }
}

export default Charts;


// WEBPACK FOOTER //
// ./src/components/RequestDataAnalysis/RequestAndReturnedSheet/AnnualBillingAnalysis/HistogramBrokenLine/Charts.js